module.exports = __webpack_public_path__ + "media/images/brands/logo_francsenergie_grand-9a44deca92b4dee0cb332587427b2049.png";